module.exports = __webpack_public_path__ + "media/images/icons/outlined/ant-cloud-1392bed090688edfbaeb6950cecf3fa1.svg";